import { styled } from '@linaria/react';

export const Wrapper = styled.div`
  width: 100%;
`;
